export const ACTIVECAMPAIGN_SCRIPT = 'activecampaign-script';
export const GTM_SCRIPT = 'googletagmanager-script';
export const NEWRELIC_SCRIPT = 'newrelic-script';
export const GOOGLEMAPS_SCRIPT = 'googlemaps-script';
export const HUBSPOT_TRACKING_SCRIPT = 'hs-script-loader';
export const GTM_JOIN_EXP_SCRIPT = 'gtm-join-exp-script';
export const ZOOCASA_MAKE_IT_RAIN_GTM_SCRIPT_SRC = 'zoocasa-make-it-rain-gtm-script-src';
export const ZOOCASA_MAKE_IT_RAIN_GTM_SCRIPT_CONFIG = 'zoocasa-make-it-rain-gtm-script-config';

export const TRUSTARC_SCRIPT = 'trustarc-script';
export const TRUSTARC_DIV_ID = 'teconsent';

export const CONSENT_BLACKBAR_DIV_ID = 'consent_blackbar';
export const COOKIE_BANNER_Z_INDEX = 9999;

export const CHAT_WIDGET_DIV_ID = 'chat-widget';
export const BANNER_DIV_ID = 'banner';
export const IMMERSIVE_SEARCH_PORTAL_ID = 'immersive-search-portal';